import React, { useState, useEffect } from 'react';
import { useLocale } from "../contexts/LocaleContext";
import { getAboutUsData } from "../api/apiService";
import PageBanner from "../components/common/PageBanner";
import AboutContent from "../components/about_us/AboutContent";

const AboutUsPage = () => {

  const { locale } = useLocale();
  const [aboutUsData, setAboutUsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAboutUsContent = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await getAboutUsData(locale);
        setAboutUsData(data);
      } catch (err) {
        setError(err.message || "Failed to load content.");
        setAboutUsData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchAboutUsContent();
  }, [locale]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[calc(100vh-200px)]">
        <p className="text-xl text-gray-500">Loading...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto p-4 text-center">
        <p className="text-red-500 text-xl">Error: {error}</p>
      </div>
    );
  }

  if (!aboutUsData) {
    return (
      <div className="container mx-auto p-4 text-center">
        <p className="text-gray-700 text-xl">Content not available.</p>
      </div>
    );
  }

  const { banner, content, pdf_cover, pdf_file } = aboutUsData;
  const bannerTitle = banner?.title;
  const bannerImageUrl = banner?.image[0]?.url;


  return (
    <div className="about-us-page">
      {/* --- A. Banner Section --- */}
      <PageBanner
        title={bannerTitle}
        titleColorIsWhite={banner?.titleColorIsWhite ?? true}
        imageUrl={bannerImageUrl}
      />

      {/* --- B. Content Section (Two Columns) --- */}
      <AboutContent
        title={bannerTitle}
        content={content}
        pdfCover={pdf_cover}
        pdfFile={pdf_file}
      />
    </div>
  );
};

export default AboutUsPage;